define("shared/components/shared/profile-categorization/rewards-steps/provide-profile-report-data", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "ember-concurrency", "later/utils/array-methods", "later/utils/number-helpers", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _emberConcurrency, _arrayMethods, _numberHelpers, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _calculateEngagementOnPosts, _processIgHashtags, _getTopUsedHashtags, _calculateHashtagFrequency;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"later/utils/array-methods",0,"later/utils/number-helpers",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div {{did-update (perform this.performAllTasks) @socialProfile}}>
    {{yield this.yieldedHash}}
  </div>
  */
  {
    "id": "KAhlj0CP",
    "block": "[[[11,0],[4,[38,0],[[28,[37,1],[[30,0,[\"performAllTasks\"]]],null],[30,1]],null],[12],[1,\"\\n  \"],[18,2,[[30,0,[\"yieldedHash\"]]]],[1,\"\\n\"],[13]],[\"@socialProfile\",\"&default\"],false,[\"did-update\",\"perform\",\"yield\"]]",
    "moduleName": "shared/components/shared/profile-categorization/rewards-steps/provide-profile-report-data.hbs",
    "isStrictMode": false
  });
  let ProvideProfileReportDataComponent = _exports.default = (_class = (_calculateEngagementOnPosts = /*#__PURE__*/new WeakSet(), _processIgHashtags = /*#__PURE__*/new WeakSet(), _getTopUsedHashtags = /*#__PURE__*/new WeakSet(), _calculateHashtagFrequency = /*#__PURE__*/new WeakSet(), class ProvideProfileReportDataComponent extends _component2.default {
    get socialProfile() {
      return this.args.socialProfile;
    }
    get followerCount() {
      return this.args.socialProfile.followedBy;
    }
    get allTasksAreLoading() {
      return this.performAllTasks.isRunning;
    }
    get profilePostsIsLoading() {
      return this.categorizationRewards.getProfilePosts.isRunning;
    }
    get getProfilePostsResult() {
      return this.categorizationRewards.getProfilePosts.lastSuccessful?.value ?? undefined;
    }
    get profileHashtagsIsLoading() {
      return this.categorizationRewards.getProfileHashtags.isRunning;
    }
    get getProfileHashtagsResult() {
      return this.categorizationRewards.getProfileHashtags.lastSuccessful?.value ?? undefined;
    }
    constructor(owner, args) {
      super(owner, args);
      _classPrivateMethodInitSpec(this, _calculateHashtagFrequency);
      _classPrivateMethodInitSpec(this, _getTopUsedHashtags);
      _classPrivateMethodInitSpec(this, _processIgHashtags);
      _classPrivateMethodInitSpec(this, _calculateEngagementOnPosts);
      _initializerDefineProperty(this, "categorizationRewards", _descriptor, this);
      _initializerDefineProperty(this, "instagram", _descriptor2, this);
      _defineProperty(this, "minimumPostsRequired", 10);
      _defineProperty(this, "minimumHashtagsRequired", 1);
      _defineProperty(this, "performAllTasks", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.socialProfile.isBusiness || this.socialProfile.isCreator) {
            const getProfilePosts = this.categorizationRewards.getProfilePosts.linked().perform(this.socialProfile);
            const getProfileHashtags = this.categorizationRewards.getProfileHashtags.linked().perform(this.socialProfile);
            yield getProfilePosts;
            yield getProfileHashtags;
          }
        }
      }), null, "performAllTasks", null));
      this.performAllTasks.perform();
    }

    // Note: template hash helper does not consistently trigger autotracking
    get yieldedHash() {
      return {
        isLoading: this.allTasksAreLoading,
        averageProfileEngagement: this.averageProfileEngagement,
        profileHashtags: this.profileHashtags,
        hasEnoughPosts: this.hasEnoughPosts,
        hasEnoughHashtags: this.hasEnoughHashtags
      };
    }
    get profilePosts() {
      return this.profilePostsIsLoading ? [] : this.getProfilePostsResult;
    }
    get hasEnoughPosts() {
      return Boolean(this.profilePosts && this.profilePosts.length >= this.minimumPostsRequired);
    }
    get averageProfileEngagement() {
      if (!this.profilePosts) {
        return;
      }
      const engagementOnPosts = _classPrivateMethodGet(this, _calculateEngagementOnPosts, _calculateEngagementOnPosts2).call(this, this.profilePosts, this.followerCount);
      if (!engagementOnPosts) {
        return;
      }
      const averageProfileEngagement = (0, _arrayMethods.calculateAverage)(engagementOnPosts) * 100;
      return (0, _numberHelpers.preciseRound)(averageProfileEngagement, 3);
    }
    get profileHashtags() {
      if (!this.getProfileHashtagsResult) {
        return;
      }
      return _classPrivateMethodGet(this, _processIgHashtags, _processIgHashtags2).call(this, this.getProfileHashtagsResult);
    }
    get hasEnoughHashtags() {
      return Boolean(this.profileHashtags && this.profileHashtags.length >= this.minimumHashtagsRequired);
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "categorizationRewards", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "instagram", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  function _calculateEngagementOnPosts2(posts, currentFollowerCount) {
    if (!this.instagram.isIgPostArray(posts)) {
      return;
    }
    return posts.map(post => {
      const likeCount = post.likeCount || 0;
      const commentCount = post.commentCount || 0;
      const followerCount = post.followersOnPost || currentFollowerCount;
      if (!followerCount) {
        return 0;
      }
      return (likeCount + commentCount) / followerCount;
    });
  }
  function _processIgHashtags2(hashtagData) {
    const frequencyOfEachHashtag = _classPrivateMethodGet(this, _calculateHashtagFrequency, _calculateHashtagFrequency2).call(this, hashtagData);
    const topTenUsedHashtags = _classPrivateMethodGet(this, _getTopUsedHashtags, _getTopUsedHashtags2).call(this, frequencyOfEachHashtag, 10);
    return topTenUsedHashtags.map(tag => `#${tag}`);
  }
  function _getTopUsedHashtags2(frequencyOfEachHashtag, numberOfHashtags) {
    return Object.keys(frequencyOfEachHashtag).sort((a, b) => frequencyOfEachHashtag[a] - frequencyOfEachHashtag[b]).reverse().slice(0, numberOfHashtags);
  }
  function _calculateHashtagFrequency2(hashtags) {
    return hashtags.reduce((previous, current) => {
      previous[current] = (previous[current] || 0) + 1;
      return previous;
    }, {});
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProvideProfileReportDataComponent);
});